import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import CurrencyDropdown from 'views/ui/form_elements/dropdown/currency';
import CurrencyActions from 'action_creators/currency';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';

const SessionCurrencyChooser = createReactClass({
  mixins: [PureRenderMixin, StoreInterestMixin],
  displayName: 'SessionCurrencyChooser',

  propTypes: {
    initialCurrency: PropTypes.string,
    supportedCurrencies: PropTypes.array,
    icon: PropTypes.node,
  },

  getDefaultProps() {
    return {
      initialCurrency: 'USD',
      supportedCurrencies: ['USD'],
      icon: null,
    };
  },

  getInitialState() {
    return {
      currency: this.props.initialCurrency,
    };
  },

  getStoreInterests() {
    return {
      currency: 'session.currency',
    };
  },

  currencyDidChange(name, newCurrency) {
    if (newCurrency !== this.state.currency) {
      CurrencyActions.changeCurrency(newCurrency);
    }
  },

  render() {
    const dropdownProps = {
      name: 'session-currency',
      currency: this.state.currency,
      supportedCurrencies: this.props.supportedCurrencies,
      onChange: this.currencyDidChange,
    };
    if (this.props.icon) {
      dropdownProps.icon = this.props.icon;
    }

    return <CurrencyDropdown {...dropdownProps} />;
  },
});

export default SessionCurrencyChooser;
